import { render, staticRenderFns } from "./InserirCertificacao.vue?vue&type=template&id=126bfa87&lang=pug"
import script from "./InserirCertificacao.vue?vue&type=script&lang=js"
export * from "./InserirCertificacao.vue?vue&type=script&lang=js"
import style0 from "./InserirCertificacao.vue?vue&type=style&index=0&id=126bfa87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports